import React from "react";

function CopyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      fill="none"
      viewBox="0 0 14 15"
    >
      <path
        fill="#fff"
        d="M2.894 6.178L1.179 7.893a3.75 3.75 0 005.304 5.303l2.285-2.286a3.75 3.75 0 00-1.035-6.035L7 5.607a1.25 1.25 0 00-.192.25 2.5 2.5 0 011.076 4.17L5.6 12.313a2.501 2.501 0 01-3.537-3.538l.99-.99a5.023 5.023 0 01-.16-1.609v.002z"
      ></path>
      <path
        fill="#fff"
        d="M4.14 6.7l.209-.209c.31-.31.696-.534 1.12-.647.113-.424.336-.81.647-1.12l.209-.21a3.755 3.755 0 00-1.825.36 3.743 3.743 0 00-.36 1.825V6.7z"
      ></path>
      <path
        fill="#fff"
        d="M5.232 3.84a3.75 3.75 0 001.035 6.035l.97-.97a2.5 2.5 0 01-1.12-4.183L8.4 2.437a2.501 2.501 0 113.537 3.538l-.99.99c.14.525.193 1.069.16 1.609l1.714-1.715a3.75 3.75 0 10-5.303-5.304L5.232 3.84z"
      ></path>
      <path
        fill="#fff"
        d="M9.5 9.875a3.738 3.738 0 00.36-1.825l-.209.209c-.31.31-.696.534-1.12.647-.113.424-.336.81-.647 1.12l-.209.209A3.755 3.755 0 009.5 9.876v-.001z"
      ></path>
    </svg>
  );
}

export default CopyIcon;
